import moment from 'moment';
import { AuthenticationService } from 'src/services/authentication.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent, DialogService, WaitButtonComponent } from '@sircon/sircon-ui-framework';
import { SessionManagementService } from 'src/services/session-management.service';

@Component({
    selector: 'app-session-management',
    templateUrl: './session-management.component.html',
    styleUrls: ['./session-management.component.less'],
    imports: [WaitButtonComponent]
})
export class SessionManagementComponent extends BaseComponent implements OnInit, OnDestroy {
    SESSION_DIALOG_TIMEOUT_SECONDS = 15 * 60; // 15 minutes, how long before the modal waits before logging the user out
    secondsUntilLogout = this.SESSION_DIALOG_TIMEOUT_SECONDS;
    formattedTimeUntilLogout = '';
    interval = window.setInterval(() => this.doIntervalCheck(), 1000);

    constructor(private authenticationService: AuthenticationService,
                private sessionManagementService: SessionManagementService,
                private dialogService: DialogService) {
        super();
    }

    ngOnInit() {
        this.formatTimeoutMessage();
    }

    ngOnDestroy() {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
    }

    formatTimeoutMessage() {
        this.formattedTimeUntilLogout = moment().startOf('day').seconds(this.secondsUntilLogout).format('m:ss');
    }

    doIntervalCheck() {
        this.secondsUntilLogout--;
        this.formatTimeoutMessage();

        if (this.secondsUntilLogout === 0) {
            if (this.interval) {
                window.clearInterval(this.interval);
            }
            this.sessionManagementService.endSession();
        }
    }

    logout() {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
        this.authenticationService.logout();
        this.dialogService.close('session-management-dialog');
    }

    endSession() {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
        this.sessionManagementService.endSession();
        this.dialogService.close('session-management-dialog');
    }

    resetSession() {
        if (this.interval) {
            window.clearInterval(this.interval);
        }
        this.sessionManagementService.resetSession();
        this.dialogService.close('session-management-dialog');
    }
}

